module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getStyle)
  }, [_c('label', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.getTitle)),
      expression: "t(getTitle)",
      arg: "tooltip"
    }],
    staticClass: "btn btn-sm btn-info"
  }, [_vm._v("\n        " + _vm._s(_vm.t(_vm.getName)) + "\n        "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onClickUploadFile
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1b776ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/UploadButtonComponent.vue
// module id = 1350
// module chunks = 2